import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API } from "../utils/api";

const AdminLoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      // Use token-based admin login
      const response = await axios.post(`${API}/auth/admin/login`, { username, password });
      if (response.data.token) {
        localStorage.setItem('adminToken', response.data.token);
        localStorage.setItem('adminUser', response.data.username);
        navigate('/admin/dashboard');
      }
    } catch (err) {
      // Fallback to old basic-auth login
      try {
        const fallback = await axios.post(`${API}/admin/login`, { username, password });
        if (fallback.data.success) {
          localStorage.setItem('adminUser', fallback.data.username);
          navigate('/admin/dashboard');
        }
      } catch (err2) {
        setError(err.response?.data?.detail || 'Invalid credentials');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-4" data-testid="admin-login">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img 
            src="https://customer-assets.emergentagent.com/job_streamking-cbx/artifacts/exnqqglo_cbxtransp.png" 
            alt="CBXTV" 
            className="h-56 mx-auto mb-4"
            style={{ filter: 'drop-shadow(0 0 3px white) drop-shadow(0 0 6px rgba(255,255,255,0.6))' }}
          />
          <p className="text-gray-400">Admin Dashboard</p>
        </div>
        
        <form onSubmit={handleLogin} className="bg-gray-900 rounded-xl p-8 border border-gray-800">
          <h2 className="text-xl font-bold text-white mb-6">Sign In</h2>
          
          {error && (
            <div className="bg-red-600/20 border border-red-600 text-red-400 px-4 py-3 rounded-lg mb-4">
              {error}
            </div>
          )}
          
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-400 mb-2">Username</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-red-600"
                placeholder="Enter username"
                data-testid="admin-username-input"
                required
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-400 mb-2">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-red-600"
                placeholder="Enter password"
                data-testid="admin-password-input"
                required
              />
            </div>
            
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-3 rounded-lg transition-colors disabled:opacity-50"
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </div>
        </form>
        
        <p className="text-center text-gray-500 text-sm mt-6">
          <a href="/" className="text-red-500 hover:underline">← Back to CBXTV</a>
        </p>
      </div>
    </div>
  );
};

export default AdminLoginPage;
